import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { PointageJournalier } from "../domain/RH/pointage-journalier";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { PointageJournalierDTO } from "./dto/pointage-journalier.dto";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class PointageService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/pointage`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getPointage() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getPointage')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: PointageJournalierDTO) => {
                return mapper.map(response, PointageJournalierDTO, PointageJournalier);         
            }));
    } 

    putPointage(pj: PointageJournalier) {
        this.loadingTask.activateLoading();
        const dto = JSON.stringify(pj);
        return this.http.put(`${this.serviceUrl}`, dto, this.generateHeader()).pipe(
            catchError(this.handleError<any>('syncPointage')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

}